import {$, Attributes, ElementDecorator} from '../util/view'
import {cast as castArray} from '../util/array'
import {getCurrentPageChannel} from '../util/channel'

export interface Options {
  attributes?: Attributes,
  baseURL: string,
  children: ElementDecorator | ElementDecorator[],
  consent: boolean
}

const createFormValue = (name: string, value: string) => (
  $('input', {
    name,
    type: 'hidden',
    value
  })
)

export default function ({
  attributes = {},
  baseURL,
  children,
  consent
}: Options): ElementDecorator {
  const builtInInputs = [
    createFormValue('consent', consent ? 'yes' : 'no'),
    createFormValue('domain', location.origin),
  ]

  const channel = getCurrentPageChannel()

  if (channel) {
    builtInInputs.push(createFormValue('channel', channel))
  }

  return (
    $('form', {
      action: `${baseURL}/../gdpr/consent?redirect=${encodeURIComponent(location.toString())}`,
      method: 'POST',
      ...attributes
    }, [
      ...builtInInputs,
      ...castArray(children)
    ])
      .submit(() => localStorage.setItem('mol.ads.cmp.alert', 'true'))
  )
}
